import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./Dates.css";
import moment from "moment";
import "moment/dist/locale/ru";
import { ru } from "date-fns/locale";

const Dates = (props) => {
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [isDropdownOpenRight, setIsDropdownOpenRight] = useState(false);
    const [selectedMonth, setSelectedMonth] = useState(moment(props.startDate));

    useEffect(() => {
        customMonthAndYear();
    }, []);

    const renderDayContents = (day) => {
        return <div>{day}</div>;
    };

    // генерирует месяцы во всплывашке выбора месяцев
    const generateMonths = (start = moment()) => {
        const months = [];
        let startMonth = start;
        for (let i = 0; i < 6; i++) {
            const tempMonth = startMonth.clone().locale("ru");
            months.push(tempMonth);
            startMonth = startMonth.add(1, "month");
        }
        return months;
    };

    const handleMonthClick = (month) => {
        setSelectedMonth(month);
        setIsDropdownOpen(false);
    };

    const handleMonthClickRight = (month) => {
        setSelectedMonth(month);
        setIsDropdownOpenRight(false);
    };

    const handleOnMonthChange = (e) => {
        customMonthAndYear();
        setSelectedMonth(moment(e));
    };

    const handleDropdownOpen = () => {
        setIsDropdownOpen(!isDropdownOpen);
        setIsDropdownOpenRight(false);
    };

    const handleDropdownOpenRight = () => {
        setIsDropdownOpenRight(!isDropdownOpenRight);
        setIsDropdownOpen(false);
    };

    const months = generateMonths();
    const monthsRight = generateMonths(moment().add(1, "month"));
    return (
        <div className="custom-date-picker">
            <div className="selected-month_container">
                <div>
                    <div
                        className="selected-month"
                        onClick={handleDropdownOpen}
                    >
                        {selectedMonth
                            ? selectedMonth.format("MMMM - YYYY")
                            : "Выберите месяц"}
                        {selectedMonth && (
                            <span className="check-down">{checkDown}</span>
                        )}
                    </div>
                    {isDropdownOpen && (
                        <div className="month-dropdown">
                            {months.map((month, index) => (
                                <div
                                    key={index}
                                    onClick={() => handleMonthClick(month)}
                                >
                                    {month.format("MMMM YYYY")}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
                <div>
                    <div
                        className="selected-month"
                        onClick={handleDropdownOpenRight}
                    >
                        {selectedMonth
                            ? selectedMonth
                                  .clone()
                                  .add(1, "months")
                                  .format("MMMM - YYYY")
                            : "Выберите месяц"}
                        {selectedMonth && (
                            <span className="check-down">{checkDown}</span>
                        )}
                    </div>
                    {isDropdownOpenRight && (
                        <div className="month-dropdown month-dropdown_right">
                            {monthsRight.map((month, index) => (
                                <div
                                    key={index}
                                    onClick={() =>
                                        handleMonthClickRight(
                                            month.subtract(1, "month"),
                                        )
                                    }
                                >
                                    {month.format("MMMM YYYY")}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
            <DatePicker
                className="content"
                dateFormat="dd.MM.yyyy"
                selected={selectedMonth.toDate()}
                onChange={(dates) => props.onDateChange(dates)}
                placeholderText="Выберите дату"
                locale={ru}
                monthsShown={2}
                inline
                startDate={props.startDate}
                endDate={props.endDate}
                selectsDisabledDaysInRange
                selectsRange
                minDate={moment().toDate()}
                maxDate={moment().clone().add(180, "days").toDate()}
                renderDayContents={renderDayContents}
                onMonthChange={handleOnMonthChange}
            />
        </div>
    );
};

export default Dates;

const checkDown = (
    <svg
        width="8"
        height="4"
        viewBox="0 0 8 4"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M7.38181 0H3.82198H0.616412C0.0678664 0 -0.206406 0.607131 0.182147 0.963036L3.14201 3.67419C3.61627 4.1086 4.38767 4.1086 4.86193 3.67419L5.98759 2.64311L7.82179 0.963036C8.20463 0.607131 7.93036 0 7.38181 0Z"
            fill="#DE210B"
        />
    </svg>
);

const customMonthAndYear = () => {
    const currentMonthElements = document.querySelectorAll(
        ".react-datepicker__current-month",
    );

    currentMonthElements.forEach((element) => {
        const textContent = element.textContent;
        const [month, year] = textContent.split(" ");
        element.innerHTML = `${month} <span>${year}</span>`;
    });
};
